import Reveal from "@/components/site/Reveal";

const faqs = [
  {
    q: "Ist das, was ich erzähle, vertraulich?",
    a: "Absolut. Alles, was wir besprechen, unterliegt meiner Verschwiegenheit. Ohne deine Zustimmung gelangt nichts nach außen.",
  },
  {
    q: "Was kostet eine Sitzung?",
    a: "Das Erstgespräch (30 Minuten) ist immer kostenlos. Eine Einzelsitzung kostet 70 €, das Begleitpaket mit fünf Sitzungen 300 €. Alle Details findest du im Abschnitt Preise.",
  },
  {
    q: "Wo findet die Beratung statt?",
    a: "Die Beratung findet online statt – flexibel und ortsunabhängig. Nach Vereinbarung ist auch ein persönliches Gespräch in Lünen möglich.",
  },
  {
    q: "Ersetzt die Beratung eine Therapie?",
    a: "Nein. Ich bin psychologischer Berater, kein Psychotherapeut und kein Arzt. Meine Beratung ist keine heilkundliche Behandlung. Bei akuten Krisen wende dich bitte an die Telefonseelsorge unter 0800 111 0 111 (kostenfrei, rund um die Uhr).",
  },
  {
    q: "Wie schnell bekomme ich einen Termin?",
    a: "Erstgespräche sind meist innerhalb weniger Tage möglich. Schreib mir einfach über das Kontaktformular – ich melde mich zeitnah bei dir.",
  },
];

export default function Faq() {
  return (
    <section id="fragen" data-testid="faq-section" className="relative py-28 sm:py-36 bg-[#EAD0AE]/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#93401D] mb-5">
              Häufige Fragen
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-[#29170C]">
              Vielleicht hilft dir
              <br />
              <span className="italic text-[#93401D]">das schon weiter.</span>
            </h2>
            <p className="mt-6 text-[#63432B] leading-relaxed">
              Deine Frage ist nicht dabei? Schreib mir einfach – ich antworte
              persönlich.
            </p>
          </Reveal>
          <div className="lg:col-span-8 divide-y divide-[#E0BD93]/60">
            {faqs.map((f, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <details data-testid={`faq-item-${i}`} className="group py-6">
                  <summary className="flex items-center justify-between cursor-pointer list-none min-h-[44px]">
                    <h3 className="font-serif text-xl text-[#29170C] pr-6">{f.q}</h3>
                    <span className="w-9 h-9 rounded-full bg-[#F2DFC6] border border-[#E0BD93] flex items-center justify-center text-[#93401D] transition-transform group-open:rotate-45 shrink-0">
                      +
                    </span>
                  </summary>
                  <p className="mt-4 text-[#63432B] leading-relaxed max-w-2xl">{f.a}</p>
                </details>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
